import React, { useState, useEffect, useRef } from 'react';
import msgs from '../data/msgs';
import '../CSS/Chat.css';

const Chat = () => {
    const [name, setName] = useState('');
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState(msgs.messages);
    const messagesEndRef = useRef(null);

    // Prompt for user's name on component mount
    useEffect(() => {
        let userName = '';
        while (!userName) {
            userName = prompt('Please enter your name:');
            if (userName) {
                setName(userName);
            }
        }
    }, []);

    // Scroll to the latest message when messages update
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const sendMessage = () => {
        if (input.trim() === '') return;
        const newMessage = {
            name: name,
            text: input,
            timestamp: new Date().toLocaleTimeString(),
        };
        msgs.addMessage(newMessage);
        setMessages([...msgs.messages]);
        setInput('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            sendMessage();
        }
    };

    return (
        <div className="chat-container">
            <h2>Chat Room - Not Available</h2>
            <h1>Under Maintenance</h1>
            <div className="chat-messages">
                {messages.map((msg, index) => (
                    <div key={index} className="chat-message">
                        <span className="chat-name">{msg.name}:</span>
                        <span className="chat-text">{msg.text}</span>
                        <span className="chat-timestamp">{msg.timestamp}</span>
                    </div>
                ))}
                <div ref={messagesEndRef} />
            </div>
            <div className="chat-input">
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Type your message..."
                />
                <button onClick={sendMessage}>Send</button>
            </div>
        </div>
    );
};

export default Chat;